<div id="map-search-pdf-page-1" class="pdf-page">
  <!-- Header -->
  <div class="header">
    <div class="header-background"></div>
    <div class="header-content">
      <img class="logo" src="assets/images/rs_logo_blue_white_inline_transparent_cropped.png" alt="Retailstat Logo" />
      <div class="export-info">
        <div class="export-label">Exported On</div>
        <div class="export-date">{{ exportDate }}</div>
        <div class="export-time">{{ exportTime }}</div>
      </div>
    </div>
  </div>

  <!-- Analysis Description -->
  <div class="analysis-description">
    <div class="description-title">User Description</div>
    <div class="description-text">{{ analysisDescription }}</div>
  </div>

  <!-- Map Section -->
  <div class="map-section">
    <div class="map-container">
      <img class="map-image" [src]="capturedMapImage" alt="Map Analysis" *ngIf="capturedMapImage" />
      <div class="no-map-message" *ngIf="!capturedMapImage">
        <p>No map captured yet</p>
        <p>Debug: capturedMapImage = {{!!capturedMapImage}}</p>
      </div>
    </div>
    <div class="store-legend-section">
      <div class="legend-title">Store Legend</div>
      <div class="legend-first-line">
        <div class="legend-item" *ngFor="let item of getFirstLineLegend()">{{ item }}</div>
      </div>
    </div>
    <div class="legend-second-line">
      <div class="legend-item" *ngFor="let item of getSecondLineLegend()">{{ item }}</div>
    </div>
  </div>

  <!-- Active Filters -->
  <div class="active-filters" *ngIf="getActiveFilterEntries().length > 0">
    <div class="filters-title">Active Filters</div>
    <div class="filters-content">
      <div class="filter-row" *ngFor="let filter of getActiveFilterEntries()">
        <span class="filter-label">{{ filter.label }}:</span>
        <span class="filter-value"> {{ filter.value }}</span>
      </div>
    </div>
  </div>

  <!-- Polygon Analysis -->
  <div class="polygon-analysis" [class.no-filters]="!showActiveFilters" *ngIf="showPolygonAnalysis">
    <div class="analysis-title">POLYGON ANALYSIS</div>
    <div class="analysis-metrics">
      <div class="metric-group">
        <div class="metric-label">Area</div>
        <div class="metric-value-primary">{{ areaSquareFeet }}</div>
        <div class="metric-label-secondary">{{ areaAcres }}</div>
      </div>
      <div class="metric-group metric-centered">
        <div class="metric-label">Perimeter</div>
        <div class="metric-value-primary">{{ perimeterFeet }}</div>
        <div class="metric-label-secondary">{{ perimeterMiles }}</div>
      </div>
      <div class="metric-group metric-centered">
        <div class="metric-label">Center Point</div>
        <div class="metric-value-secondary">{{ centerPointLat }}</div>
        <div class="metric-value-secondary">{{ centerPointLong }}</div>
      </div>
    </div>
  </div>

  <!-- Store Locations Table on Page 1 (when either filters or analysis missing) -->
  <div class="store-table-container page-1-table" [class.no-sections]="!showActiveFilters && !showPolygonAnalysis" *ngIf="!showActiveFilters || !showPolygonAnalysis">
    <div class="table-title">FILTERD LOCATIONS ({{ totalStoreCount }} STORES)</div>
    <div class="store-table">
      <!-- Table Header -->
      <div class="table-header-row">
        <div class="table-header-cell store-name-cell">
          <div class="cell-content centered">
            <div class="header-text">Store Name</div>
          </div>
        </div>
        <div class="table-header-cell banner-cell">
          <div class="cell-content centered">
            <div class="header-text">Banner</div>
          </div>
        </div>
        <div class="table-header-cell format-cell">
          <div class="cell-content centered">
            <div class="header-text">Format</div>
          </div>
        </div>
        <div class="table-header-cell address-cell">
          <div class="cell-content centered">
            <div class="header-text">Address</div>
          </div>
        </div>
      </div>

      <!-- Table Rows for Page 1 -->
      <div *ngIf="totalStoreCount === 0" class="no-stores-message">
        No stores available
      </div>
      <div
        *ngFor="let store of getStoresForPage(1); let i = index"
        class="table-row"
        [class.row-white]="i % 2 === 0"
        [class.row-gray]="i % 2 !== 0">
        <div class="table-cell store-name-cell">
          <div class="cell-content centered">
            <div class="cell-text">{{ store.storeName }}</div>
          </div>
        </div>
        <div class="table-cell banner-cell">
          <div class="cell-content centered">
            <div class="cell-text">{{ store.banner }}</div>
          </div>
        </div>
        <div class="table-cell format-cell">
          <div class="cell-content centered">
            <div class="cell-text">{{ store.format }}</div>
          </div>
        </div>
        <div class="table-cell address-cell">
          <div class="cell-content centered">
            <div class="cell-text">{{ store.address }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer">
    <div class="footer-left">retailstat.com</div>
    <div class="footer-right">Page 1 of {{ getTotalPages() }}</div>
  </div>
</div>

<!-- Second Page - Store Locations Table (only when both filters and analysis present) -->
<div id="map-search-pdf-page-2" class="pdf-page" *ngIf="showActiveFilters && showPolygonAnalysis">
  <!-- Table Title Section -->
  <div class="table-title-section">
    <div class="table-title">FILTERD LOCATIONS ({{ totalStoreCount }} STORES)</div>
  </div>

  <!-- Store Locations Table -->
  <div class="store-table-container">
    <div class="store-table">
      <!-- Table Header -->
      <div class="table-header-row">
        <div class="table-header-cell store-name-cell">
          <div class="cell-content centered">
            <div class="header-text">Store Name</div>
          </div>
        </div>
        <div class="table-header-cell banner-cell">
          <div class="cell-content centered">
            <div class="header-text">Banner</div>
          </div>
        </div>
        <div class="table-header-cell format-cell">
          <div class="cell-content centered">
            <div class="header-text">Format</div>
          </div>
        </div>
        <div class="table-header-cell address-cell">
          <div class="cell-content centered">
            <div class="header-text">Address</div>
          </div>
        </div>
      </div>

      <!-- Table Rows for Page 2 -->
      <div
        *ngFor="let store of getStoresForPage(2); let i = index"
        class="table-row"
        [class.row-white]="i % 2 === 0"
        [class.row-gray]="i % 2 !== 0">
        <div class="table-cell store-name-cell">
          <div class="cell-content centered">
            <div class="cell-text">{{ store.storeName }}</div>
          </div>
        </div>
        <div class="table-cell banner-cell">
          <div class="cell-content centered">
            <div class="cell-text">{{ store.banner }}</div>
          </div>
        </div>
        <div class="table-cell format-cell">
          <div class="cell-content centered">
            <div class="cell-text">{{ store.format }}</div>
          </div>
        </div>
        <div class="table-cell address-cell">
          <div class="cell-content centered">
            <div class="cell-text">{{ store.address }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer">
    <div class="footer-left">retailstat.com</div>
    <div class="footer-right">Page 2 of {{ getTotalPages() }}</div>
  </div>
</div>

<!-- Additional Pages for Overflow Stores -->
<div *ngFor="let pageNum of getAdditionalPages()" [id]="'map-search-pdf-page-' + pageNum" class="pdf-page">
  <!-- Store Locations Table Continued -->
  <div class="store-table-container">
    <div class="store-table">
      <!-- Table Header -->
      <div class="table-header-row">
        <div class="table-header-cell store-name-cell">
          <div class="cell-content centered">
            <div class="header-text">Store Name</div>
          </div>
        </div>
        <div class="table-header-cell banner-cell">
          <div class="cell-content centered">
            <div class="header-text">Banner</div>
          </div>
        </div>
        <div class="table-header-cell format-cell">
          <div class="cell-content centered">
            <div class="header-text">Format</div>
          </div>
        </div>
        <div class="table-header-cell address-cell">
          <div class="cell-content centered">
            <div class="header-text">Address</div>
          </div>
        </div>
      </div>

      <!-- Table Rows for Additional Pages -->
      <div
        *ngFor="let store of getStoresForPage(pageNum); let i = index"
        class="table-row"
        [class.row-white]="i % 2 === 0"
        [class.row-gray]="i % 2 !== 0">
        <div class="table-cell store-name-cell">
          <div class="cell-content centered">
            <div class="cell-text">{{ store.storeName }}</div>
          </div>
        </div>
        <div class="table-cell banner-cell">
          <div class="cell-content centered">
            <div class="cell-text">{{ store.banner }}</div>
          </div>
        </div>
        <div class="table-cell format-cell">
          <div class="cell-content centered">
            <div class="cell-text">{{ store.format }}</div>
          </div>
        </div>
        <div class="table-cell address-cell">
          <div class="cell-content centered">
            <div class="cell-text">{{ store.address }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer">
    <div class="footer-left">retailstat.com</div>
    <div class="footer-right">Page {{ pageNum }} of {{ getTotalPages() }}</div>
  </div>
</div>
